import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  transform(dtString: string, locale: string, withTime: boolean): any {
    if (!dtString) return;
    if (locale) {
      locale = locale.replace('_', '-')
    } else {
      locale = 'fr-FR';
    }
    var dt = new Date(dtString);

    if (withTime) {
      return dt.toLocaleDateString(locale, {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });
    } else {
      return dt.toLocaleDateString(locale, {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric'
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/date-format/date-format.ts